module.exports = __webpack_public_path__ + "static/favicon2025-046191919edb4791bdbfdf53a27f2f11.png";